import { licenseCheckLatestStatusEntityName } from '../../../../backend/features/credentialing-verification/shared';
import { useLicenseCheckLatestStatusColumns } from '../../../../ui/features/credentialing-verification/hooks/useLicenseCheckLatestStatusColumns';
import { useLicenseCheckLatestStatusFilterConfig } from '../../../../ui/features/credentialing-verification/hooks/useLicenseCheckLatestStatusFilterConfig';
import { mapLicenseCheckLatestStatusFilter, } from '../../../../ui/features/credentialing-verification/utils/mapLicenseCheckLatestStatusFilter';
import { useCredentialingTranslation } from '../../../../ui/hooks';
import { CredentialingContext } from '../../../../ui/providers/credentialing-context';
import { useDataTableUsingUrl } from '@juvare/common-data-table-ui/DataTable';
import { FiltersBar } from '@juvare/common-data-table-ui/FiltersBar';
import { useResolvedAccountFilter, useResolvedAdvancedSearchItems } from '@juvare/contact-management/ui/features/accounts/hooks';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import React from 'react';
export function useCredentialVerificationDetailsTable({ reviewProfileTabName, expiringOnlyFilter, }) {
    const { t } = useCredentialingTranslation();
    const { onPersonSelect } = React.useContext(CredentialingContext);
    const userState = useUserState();
    const filterConfig = useLicenseCheckLatestStatusFilterConfig();
    const advancedSearchItems = useResolvedAdvancedSearchItems();
    const params = {
        useDataProvider: ({ filterData, limit, offset, sortColumnKey, sortColumnDesc }) => {
            const { data: accountFilter } = useResolvedAccountFilter({
                filterData,
                advancedSearchItems,
            });
            const mappedFilters = mapLicenseCheckLatestStatusFilter(userState, filterData, expiringOnlyFilter, accountFilter);
            const response = useStorageList(licenseCheckLatestStatusEntityName, {
                filter: mappedFilters,
                limit,
                offset,
                orderBy: [
                    {
                        column: sortColumnKey,
                        desc: sortColumnDesc,
                    },
                ],
            });
            return Object.assign(Object.assign({}, response), { data: response.data
                    ? {
                        rows: response.data.rows,
                        filteredRowCount: response.data.total,
                    }
                    : undefined, reload: () => {
                    void response.mutate();
                } });
        },
        defaultSortColumnKey: 'requestDate',
        defaultSortColumnDesc: true,
        rowSelectionEnabled: true,
        onRowClick: ({ columns }) => onPersonSelect(columns.personId),
    };
    const { dataTableProps, filtersBarProps, clearActiveRow, appliedFilterData, reload } = useDataTableUsingUrl(params);
    const defaultColumns = useLicenseCheckLatestStatusColumns(reviewProfileTabName);
    return {
        dataTableProps: Object.assign(Object.assign({}, dataTableProps), { title: t('credentialVerificationsPage.title'), columns: defaultColumns, filtersBar: React.createElement(FiltersBar, Object.assign({}, filtersBarProps, { config: filterConfig })) }),
        filtersBarProps,
        appliedFilterData,
        clearActiveRow,
        reload,
    };
}
